export default __webpack_public_path__ + "static/media/programs-cancer.c1eadcc9.png";